import { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import quizPreinfoState from "../../recoil/quizPreinfo"

const usePreinfoPhaseConditions = () => {
  const [isDetailRequired, setIsDetailRequired] = useState(false)
  const [isPreinfoAnswered, setIsPreinfoAnswered] = useState(false)
  const preinfo = useRecoilValue(quizPreinfoState)

  useEffect(() => {
    if (["문과", "이과", "예체능"].includes(preinfo.major)) {
      setIsDetailRequired(true)
    } else {
      setIsDetailRequired(false)
    }
  }, [preinfo.major])

  useEffect(() => {
    if (preinfo.major === "잘 모르겠습니다" || preinfo.detailedMajor !== "") {
      setIsPreinfoAnswered(true)
    } else {
      setIsPreinfoAnswered(false)
    }
  }, [preinfo])

  return { isDetailRequired, isPreinfoAnswered }
}

export default usePreinfoPhaseConditions
